import { Box } from '@mui/material';

import SectionItemProps from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const SectionItem: React.FC<SectionItemProps> = (props) => {
  const {
    hide = false,
    sectionKey,
    children,
    mainSectionKey = 'carDetailSection_',
  } = props;

  if (hide) return null;
  return (
    <Box {...props} key={sectionKey} id={`${mainSectionKey}${sectionKey}`}>
      {children}
    </Box>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SectionItem;
